import React, { Component } from "react";
import PropTypes from "prop-types";
import ModalContainer from "../../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import { mapToObjectDDL } from "../../../../../common/mapper";
import FlexView from "react-flexview";

class InventoryUnitPrint extends Component {
  render() {
    const {
      error,
      dataCabang,
      handleSelectCabang,
      onClickClose,
      onPrint,
      visible,
    } = this.props;

    return (
      <SimpleModal
        title="Print Inventory"
        visible={visible}
        styles={{ width: "50%" }}
        onClickClose={() => onClickClose()}
        content={
          <ModalContainer>
            <FlexView vAlignContent="center" hAlignContent="center">
              <div>
                <SimpleDDL
                  id="select_options_kode_cabang"
                  box="multiselect"
                  name="kodeCabang"
                  containerclassname="width width-500px margin-top-20px"
                  placeholder="Nama Cabang"
                  options={dataCabang.map((item) =>
                    mapToObjectDDL(item.namaDealer, item.kodeCabang)
                  )}
                  onChange={(value) => handleSelectCabang(value)}
                />
                {error && (
                  <p className="txt-site txt-11 color-red margin-top-5px">
                    {error}
                  </p>
                )}
              </div>
              <div style={{ textAlign: "right" }}>
                <SimpleButton
                  className={error ? "margin-bottom-15px" : ""}
                  onClick={() => onPrint()}
                  text="Print"
                />
              </div>
            </FlexView>
          </ModalContainer>
        }
      />
    );
  }
}

InventoryUnitPrint.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClickClose: PropTypes.func.isRequired,
  onPrint: PropTypes.func.isRequired,
  dataCabang: PropTypes.arrayOf(
    PropTypes.shape({
      namaDealer: PropTypes.string.isRequired,
      kodeCabang: PropTypes.string.isRequired,
    })
  ).isRequired,
  handleSelectCabang: PropTypes.func.isRequired,
};

export default InventoryUnitPrint;
